/**
 * Status on File meta object to inform view of the status of the file.
 */
export enum FileState {
  UPLOADING,
  SETTLED,
  INVALID,
}

export interface FileExtendedDetails extends FileDetails {
  file?: File;
  attachmentType?: string;
  status: FileState;
  uploadedFromLegitimation?: boolean;
}

/**
 * Interface for FileDetail as defined by E-tjänst backend
 */
export interface FileDetails {
  OriginalFilename?: string;
  FileId?: string;
}
